<ul class="list-group">
	@for (category of categoryViews; track category) {
		<li
			[style.marginLeft.rem]="getTreeCategoryIndent(category)"
			[style.width]="'calc(100% - ' + getTreeCategoryIndent(category) + 'rem)'"
			[class.d-flex]="isTreeCategoryVisible(category)"
			[class.d-none]="!isTreeCategoryVisible(category)"
			[class.active]="categoryId !== undefined && category.categoryId === categoryId"
			(click)="treeCategoryClicked(category)"
			class="category-list-item list-group-item d-flex justify-content-between align-items-center list-group-item-action p-0 border-white"
			data-toggle="list"
			role="tab">
			<div class="d-flex flex-row">
				@if (!category.categoryId) {
					<div class="px-1 cursor-pointer arrow-width">
						<img [ngClass]="getTreeCategoryFolderIcon(category)" class="mask-settings bg-gray-800" />
					</div>
				}
				@if (category.categoryId) {
					<div class="px-1">
						<div style="width: 0.7rem"></div>
					</div>
				}
				<div>
					<label>
						<div class="pt-input-label">
							{{ category.view }}
						</div>
					</label>
				</div>
			</div>
		</li>
	}
</ul>
